import { API } from './api';

export type PlatformBranding = {
  system_name: string;
  company_name: string;
  company_name_en: string;
  logo_url: string;
  updated_at?: string;
};

export const DEFAULT_BRAND_LOGO = './brand/logo-horizontal.png?v=3';
export const DEFAULT_COMPANY_NAME = '经纬循道信息';
export const DEFAULT_COMPANY_NAME_EN = 'GridOrbit';

export function resolveBrandLogoUrl(logoUrl?: string | null): string {
  const u = (logoUrl || '').trim();
  return u || DEFAULT_BRAND_LOGO;
}

export async function fetchPublicBranding(): Promise<PlatformBranding> {
  try {
    const r = await fetch(`${API}/api/v1/auth/branding`);
    const d = (await r.json()) as { code?: number; data?: Partial<PlatformBranding> };
    if (d.code === 0 && d.data) {
      return {
        system_name: String(d.data.system_name || ''),
        company_name: String(d.data.company_name || ''),
        company_name_en: String(d.data.company_name_en || ''),
        logo_url: String(d.data.logo_url || ''),
        updated_at: d.data.updated_at ? String(d.data.updated_at) : undefined,
      };
    }
  } catch {
    /* keep defaults */
  }
  return {
    system_name: '',
    company_name: '',
    company_name_en: '',
    logo_url: '',
  };
}

export function displayCompanyName(b?: Partial<PlatformBranding> | null): string {
  return (b?.company_name || '').trim() || DEFAULT_COMPANY_NAME;
}

export function displayCompanyNameEn(b?: Partial<PlatformBranding> | null): string {
  return (b?.company_name_en || '').trim() || DEFAULT_COMPANY_NAME_EN;
}

export function displaySystemName(
  b?: Partial<PlatformBranding> | null,
  fallback = 'MOM数智平台',
): string {
  return (b?.system_name || '').trim() || fallback;
}
